
type LogLevel = 'off' | 'error' | 'warn' | 'info' | 'debug'
const LOG_MESSAGE_PREFIX = 'TurnTo'
const LEVEL_VALUES = {
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4
}

let logLevel: LogLevel = process.env.NODE_ENV === 'development' ? 'debug' : 'error'
let logTrace = false

export function setLogLevel(level: LogLevel) {
  if (LEVEL_VALUES[level] === undefined) {
    // tslint:disable-next-line:no-console
    console.error(`Invalid log level, '${level}'`)
    return
  }
  logLevel = level
}

export function setLogTrace(trace: boolean) {
  logTrace = trace
}

function log(level: LogLevel) {
  return function (msg, error?) {
    if (LEVEL_VALUES[level] > LEVEL_VALUES[logLevel]) {
      return
    }
    const message = `${LOG_MESSAGE_PREFIX}: (${level}) ${msg}`
    if (logTrace) {
      try {
        throw new Error()
      } catch (e) {
        console[level](message, error || '')
        console[level](e.stack.split('\n').slice(2).join('\n'))
      }
      return
    }
    console[level](message, error || '')
  }
}

export default {
  error: log('error'),
  warn: log('warn'),
  info: log('info'),
  debug: log('debug')
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/logger.ts